export enum PrivilegesEnum {
  ChangeUnitNameEndpoint = 'Teagle-Visibility-Unit-ChangeName',
  TeagleMapGoogleMaps = 'Teagle-Visibility-Map-GoogleMaps',
  TeagleMapMapBox = 'Teagle-Visibility-Map-MapBox',
  TeagleMapOSM = 'Teagle-Visibility-Map-OSM',
  ChangeUnitName = 'Privilege-UnitsController-ChangeUnitNameEndpoint',
  VehiclesSettings = 'Teagle-Visibility-Vehicles-Settings',
  UnitStatusUpdate = 'Api-Unit-Status-Update',
  UnitsUpdate = 'Api-Units-Update'
}
